import { froalaToolbars, froalaFonts } from "./config";
import { TOOLBAR_TYPES } from "./constants";

/**
 * Gets the toolbar configuration based on the toolbar name
 * @param {Object} params - The parameters object
 * @param {string} [params.toolbarName=TOOLBAR_TYPES.FULL] - The name of the toolbar to get
 * @returns {Object} The toolbar configuration object
 */
export const getToolbars = ({ toolbarName = TOOLBAR_TYPES.FULL }) => {
  return froalaToolbars[toolbarName];
};

/**
 * Gets the font families configuration for the editor by combining theme fonts with default fonts
 * @returns {Object} Object containing font configurations
 */
export const getFontFamilies = () => {
  // Get CSS-vars from :root
  const primaryFont = getComputedStyle(document.documentElement)
    .getPropertyValue("--primaryFont")
    .trim();
  const primaryTextFont = getComputedStyle(document.documentElement)
    .getPropertyValue("--primaryTextFont")
    .trim();

  const themeSpecificFonts = {};
  const excludedFonts = ["Nunito", "Poppins"];

  if (
    primaryFont &&
    !excludedFonts.some((font) => primaryFont.includes(font))
  ) {
    const fontName = primaryFont.replace(/["']/g, "").split(",")[0].trim();
    themeSpecificFonts[`${fontName}`] = primaryFont;
  }

  if (
    primaryTextFont &&
    !excludedFonts.some((font) => primaryTextFont.includes(font))
  ) {
    const fontName = primaryTextFont.replace(/["']/g, "").split(",")[0].trim();
    themeSpecificFonts[`${fontName}`] = primaryTextFont;
  }
  const fonts = froalaFonts || {};

  return { ...themeSpecificFonts, ...fonts };
};

/**
 * Gets the Froala Editor license key from the server or session storage
 * @returns {Promise<string>} A promise that resolves to the license key
 */
export const getLicenseKey = async () => {
  const cachedLicense = sessionStorage.getItem("froalaLicense");
  if (cachedLicense) {
    return cachedLicense;
  }

  const licenseKey = await fetch("/LuvitApi/v1/adminsettings/")
    .then((response) => response.json())
    .then((data) => {
      const row = Array.isArray(data.settings)
        ? data.settings.find((s) => s.settingName === "froalaLicenseKey")
        : null;
      return row?.settingValue;
    });

  sessionStorage.setItem("froalaLicense", licenseKey || "");
  return licenseKey;
};
